export const VALIDATION_MESSAGES = {
    ENTER_MANDATORY_FIELD: "message.mandatoryField",
    INVALID_NAME: "message.invalidName",
    FIELD_REQUIRED: "message.fieldRequired",
    MAX_LENGTH_100: "message.maxLength100",
    INVALID_STATE: "message.invalidState",
    INVALID_ZIP_CODE: "message.invalidZip",
    INVALID_EMAIL: "message.invalidEmail",
    INVALID_CITY: "message.invalidCity",
    QUANTITY_RANGE_ERROR: "message.quantityRangeError",
    HEATING_TEMPERATURE_RANGE_ERROR: "message.heatingTemperatureRangeError",
    COOLING_TEMPERATURE_RANGE_ERROR: "message.coolingTemperatureRangeError",
    EMITTER_TYPE_EXISTS: "message.emitterTypeExists",
    MIN_MAX_RANGE_ERROR: "message.minMaxRangeError",
    EMITTER_REQUIRED: "message.emitterRequired",
    REQUIRED_CAPACITY_MIN_MAX_ERROR: "message.capacityMinMaxError",
    HEATING_REQUIRED: "message.heatingRequired",
    COOLING_REQUIRED: "message.coolingRequired",
    ZERO_COOLING_TEMP_RANGE: "message.zeroCoolingTempRange",
    ZERO_HEATING_TEMP_RANGE: "message.zeroHeatingTempRange",
    INVALID_CAPACITY: "message.invalidCapacity",
    DBT_HEATING_TEMPERATURE_RANGE_ERROR: "message.dbtHeatingTemperatureRangeError",
    DBT_COOLING_TEMPERATURE_RANGE_ERROR: "message.dbtCoolingTemperatureRangeError",
    WBT_HEATING_TEMPERATURE_RANGE_ERROR: "message.wbtHeatingTemperatureRangeError",
    DBT_HEATING_REQUIRED: "message.dbtHeatingRequired",
    DBT_COOLING_REQUIRED: "message.dbtCoolingRequired",
    WBT_HEATING_REQUIRED: "message.wbtHeatingRequired"

}

export const MESSAGE_TITLES = {
    SUCCESS: "messageTiles.success",
    WARNING: "messageTiles.warning",
    ERROR: "messageTiles.error",
};

export const MESSAGE_TYPES = {
    PROJECT_CREATED_ERROR: "message.createProjectError",
    PROJECT_RETIVAL_ERROR: "message.retrieveProjectError",
}

export const PROJECT_MESSAGES = {
    APPLICATION_TYPE_REQUIRED: 'message.applicationTypeRequired',
    APPLICATION_TYPE_SELECTED: 'message.applicationTypeSelected',
    APPLICATION_TYPE_FAILED: 'message.applicationTypeFailed',
    CONSTRUCTION_TYPE_REQUIRED: 'message.constructionTypeRequired',
    CONSTRUCTION_TYPE_SELECTED: 'message.constructionTypeSelected',
    CONSTUCTION_TYPE_FAILED: 'message.constructionTypeFailed',
    SYSTEM_DESIGN_SELECTED: 'message.systemDesignSelected',
    SYSTEM_DESIGN_FAILED: 'message.systemDesignFailed',
    LINK_QUOTE: "message.linkQuote",
}

export const PRODUCT_MESSAGES = {
    LOAD_ERROR: 'message.loadError',
}

export const CHOOSE_PROJECT_MESSAGES = {
    LINK_QUOTE: 'message.dcLinkQuote',
    RELINK_QUOTE: 'message.relinkQuote',
    SELECT_QUOTE_REQUIRED: 'message.selectQuoteRequired',
    DC_PROJECTS_LOAD_ERROR: 'message.dcProjectsLoadError',
}

export const USER_MESSAGES = {
    USER_NOT_FOUND: 'message.userNotFound',
}

export const WARNING_MESSAGES = {
    PRODUCT_DELETE_WARNING_MESSAGE: 'message.deleteProduct',
    EMITTER_DELETE_WARNING_MESSAGE: 'message.deleteEmitter',
}

export const USER_PREFERENCE_MESSAGES = {
    PREFERENCES_UPDATED: 'message.preferencesUpdated',
    PREFERENCES_UPDATED_FAILED: 'message.preferencesUpdatedFailed',
    VALIDATION_CALC_PARAMETERS: 'message.validationCalculationParameters',
}

export const EMITTER_MESSAGES = {
    ACCESSORIES_UPDATED: 'message.accessoriesUpdated',
}
